import { Table, Flex, Button, message } from 'antd';
import { useEffect, useState } from 'react';
import { backendUrl } from '../../Config';
import { ajaxFetchCall } from '../../services/ApiService';
import { appendKey, convertToGraphQl, createGraphQlFilters, createSortOrder } from '../../services/GarphQlConversionService';
import { getColumns, getGraphQlItems } from './config';
import moment from 'moment';
import { useSearchParams } from "react-router-dom";
import MyDatePicker from '../antdCommon/DatePicker';
import Tags from "../tags/tags"
import { createTableFiltersForMutualFunds } from '../../services/TableFilter';
import { getDateParams, getFilterParams, getPaginationParams, getSorterParams, setQueryParams } from '../../utils/state_query_param_util';
import { getDateRange } from '../../utils/date_range_util';

export default function MutualFundNav(props) {

    const [searchParams, setSearchParams] = useSearchParams();
    const { RangePicker } = MyDatePicker;
    const [dataSource, setDataSource] = useState([])
    const graphqlName = "GrowwMutualFundNavPagination"
    let [loading, setLoading] = useState(false)
    // const [dateDefaultValue, setDateDefaultValue] = useState(getDateParams(searchParams))
    const [dateDefaultValue, setDateDefaultValue] = useState([moment().startOf('day'), moment().endOf('day')])
    const [pagination, setPagination] = useState(getPaginationParams(searchParams))

    const [filters, setFilters] = useState(getFilterParams(searchParams))

    const [sorter, setSorter] = useState(getSorterParams(searchParams))
    const [lastUpdated, setLastUpdated] = useState("")

    const graphQlItems = getGraphQlItems()


    const [columns, setColumns] = useState(getColumns(filters));
    let [allMutualFunds, setAllMutualFunds] = useState([])
    useEffect(() => {
        getData()
        setQueryParams(setSearchParams, filters, pagination, sorter, dateDefaultValue)
    }, [dateDefaultValue, filters, sorter])

    useEffect(() => {
        if (dataSource[0] && dataSource[0].updatedAt) {
            let maxUpdatedAt = dataSource.reduce((max, item) => {
                return max < item.updatedAt ? item.updatedAt : max;
            }, dataSource[0].updatedAt);
            setLastUpdated(new Date(maxUpdatedAt).toLocaleString())
        }
    }, [dataSource])


    const getData = async () => {
        let sort = createSortOrder(sorter)
        let graphqlFilters = createGraphQlFilters(filters)

        let q1 = convertToGraphQl(graphqlName, graphqlFilters, graphQlItems, sort, pagination.current, pagination.pageSize, dateDefaultValue, 'date')

        let body = JSON.stringify({
            query: q1
        });
        setLoading(true)
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })
        for (let l of data["data"][graphqlName]["items"]) {
            l["mutualFund"] = l["mutualFund"]["fund_name"]
            l["nav"] = l["nav"] ? l["nav"].toFixed(2) : ""
            l["navDiffFromLastDay"] = l["navDiffFromLastDay"] ? l["navDiffFromLastDay"].toFixed(2) : ""
            l["shareNavDiffFromLastDay"] = l["shareNavDiffFromLastDay"] ? l["shareNavDiffFromLastDay"].toFixed(2) : ""
        }
        appendKey(data["data"][graphqlName]["items"])
        setLoading(false)
        setDataSource(data["data"][graphqlName]["items"])
        let tempPagination = { ...pagination }
        tempPagination["total"] = data["data"][graphqlName]["pageInfo"]["itemCount"]
        setPagination(tempPagination)

    }

    const onChange = (pagination, filters, sorter, extra) => {
        setPagination(pagination)
        setFilters(filters)
        let tempCols = [...columns]
        for (let filter in filters) {
            for (let col in tempCols) {
                if (tempCols[col].key == filter) {
                    tempCols[col].filteredValue = filters[filter]
                }
            }
        }
        setColumns(tempCols)
        setSorter(sorter)
    }

    const dateChange = (dates) => {
        setDateDefaultValue(dates)
    }

    const triggerNavCron = async () => {
        let data = await ajaxFetchCall(backendUrl + "/job/triggerJob", {
            method: "POST",
            body: JSON.stringify({ jobName: "GET_CANDLE_OF_ALL_STOCKS_1_DAY" })
        })
        message.success('Collecting Data for NAV Trigger. Update Soon.', 10);
    }


    useEffect(async () => {
        let q1 = convertToGraphQl("GrowwMutualFundPagination", null, ["fund_name", "_id"], null, 0, 5000)

        let body = JSON.stringify({
            query: q1
        });
        setLoading(true)
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })

        let tempCols = [...columns]
        tempCols[0]["filters"] = createTableFiltersForMutualFunds(data["data"]["GrowwMutualFundPagination"]["items"])
        let tempMutualFunds = []
        if (data["data"]["GrowwMutualFundPagination"]["items"]) {
            data["data"]["GrowwMutualFundPagination"]["items"].map((item) => {
                tempMutualFunds[item["_id"]] = item["fund_name"]
            })
        }
        setAllMutualFunds(tempMutualFunds)
        setColumns(tempCols)
        await getData()
    }, [])

    return (
        <Flex align='' vertical>
            <Flex justify='space-between'>
                <RangePicker
                    presets={getDateRange()}
                    defaultValue={dateDefaultValue} onChange={dateChange} />
                <Button type="primary" onClick={triggerNavCron}>Latest Mutual Fund Nav</Button>
            </Flex>
            <Flex gap="middle">
                <Tags tags={filters} values={allMutualFunds}></Tags>
                <Flex style={{ paddingTop: '15px' }} >
                    <Button >
                        {lastUpdated}
                    </Button>
                </Flex>


            </Flex>
            <Table loading={loading} scroll={{ x: 1500, y: 1500 }} dataSource={dataSource} columns={columns} onChange={onChange} pagination={pagination} />
        </Flex >

    );
}